import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import styled, { withTheme } from 'styled-components';
import { generalBackground } from '../../theme/theme-style.js';
import '../../App.css.js';
import img$3 from '../../images/app_screen.svg.js';
import img$2 from '../../images/button-app-store.svg.js';
import img$1 from '../../images/button-play-store.svg.js';
import img from '../../images/youngplatform.svg.js';
import Text from '../text/text.component.js';
var _excluded = ["style", "titleText", "background", "LinkComponent", "img", "theme", "onClick"];
var Container = styled.div.withConfig({
  displayName: "banner-appcomponent__Container",
  componentId: "sc-tu99rf-0"
})(["width:100%;display:flex;flex-direction:row;align-items:center;box-sizing:border-box;border-radius:24px;padding-left:72px;padding-right:72px;padding-top:34px;.screen-app{margin-left:24px;}.header{width:50%;align-items:start;& > img{margin-bottom:34px;}}.img-container{width:50%;}@media screen and (max-width:900px){flex-direction:column;padding-left:24px;padding-right:24px;.screen-app{margin-top:48px;margin-left:0px;}.header{width:100%;align-items:center;& > img{margin-bottom:24px;}}.img-container{width:100%;}}", ""], function (props) {
  return props.color.lastIndexOf("#") >= 0 || props.color.lastIndexOf("var") >= 0 ? "background-color: " + props.color : generalBackground;
});
var ContainerButtons = styled.div.withConfig({
  displayName: "banner-appcomponent__ContainerButtons",
  componentId: "sc-tu99rf-1"
})(["display:flex;flex-direction:row;align-items:center;margin-top:34px;& > * + *{margin-left:16px;}a{height:56px;}@media screen and (max-width:900px){display:flex;flex-direction:row;justify-content:center;margin-top:24px;min-width:100%;a{height:40px;}& > * + *{margin-left:8px;}}"]);
var Image = styled.img.withConfig({
  displayName: "banner-appcomponent__Image",
  componentId: "sc-tu99rf-2"
})(["height:56px;@media screen and (max-width:900px){height:40px;}"]);
var TextTitle = styled(Text).withConfig({
  displayName: "banner-appcomponent__TextTitle",
  componentId: "sc-tu99rf-3"
})(["@media screen and (max-width:900px){text-align:center;}@media screen and (max-width:768px){font-family:EuclidCircularA-Bold,Arial;font-weight:700;font-size:48px;line-height:57px;}"]);
var BannerApp = function BannerApp(_ref) {
  var style = _ref.style,
    titleText = _ref.titleText,
    background = _ref.background;
  _ref.LinkComponent;
  var img$4 = _ref.img;
  _ref.theme;
  var onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Container, _extends({
    color: background,
    style: style
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    className: "header",
    style: {
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: img$4 || img
  }), /*#__PURE__*/React__default.createElement(TextTitle, {
    fontFamily: "euclid",
    type: "display",
    fontSize: "small",
    color: "var(--light-gray-9)",
    style: {
      whiteSpace: "break-spaces"
    }
  }, titleText), /*#__PURE__*/React__default.createElement(ContainerButtons, null, /*#__PURE__*/React__default.createElement("a", {
    href: "https://youngexchange.page.link/dr8x",
    onClick: onClick,
    style: {
      cursor: "pointer"
    }
  }, /*#__PURE__*/React__default.createElement(Image, {
    src: img$1
  })), /*#__PURE__*/React__default.createElement("a", {
    href: "https://youngexchange.page.link/sBwZ",
    onClick: onClick,
    style: {
      cursor: "pointer"
    }
  }, /*#__PURE__*/React__default.createElement(Image, {
    src: img$2
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "img-container",
    style: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: img$3,
    className: "screen-app"
  })));
};
var bannerApp_component = withTheme(BannerApp);
export { bannerApp_component as default };